import { render, staticRenderFns } from "./ScreenSizes.vue?vue&type=template&id=5dc3321e&"
import script from "./ScreenSizes.vue?vue&type=script&lang=js&"
export * from "./ScreenSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../dates/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports